<template>
  <div class="form-password-wrapper">
    <v-form ref="form" v-model="formValido" class="dark-form">
      <div class="field">
        <label class="field-label">Nueva contraseña</label>
        <v-text-field
          v-model="nuevaPassword"
          :append-icon="mostrarNueva ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="mostrarNueva ? 'text' : 'password'"
          outlined
          dense
          counter
          hide-details="auto"
          placeholder="Mínimo 8 caracteres"
          class="dark-input"
          @click:append="mostrarNueva = !mostrarNueva"
        />
      </div>

      <div class="field">
        <label class="field-label">Repetir contraseña</label>
        <v-text-field
          v-model="repitePassword"
          :append-icon="mostrarRepetida ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="mostrarRepetida ? 'text' : 'password'"
          outlined
          dense
          counter
          hide-details="auto"
          placeholder="Repite la contraseña"
          class="dark-input"
          @click:append="mostrarRepetida = !mostrarRepetida"
        />
      </div>
    </v-form>

    <div class="form-actions">
      <button class="btn-primary" :disabled="!formValido" @click="cambiarPassword">
        Actualizar
      </button>
    </div>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top right>
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";

export default {
  name: "FormCambiarPassword",
  props: {
    idUsuario: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    formValido: false,
    nuevaPassword: "",
    repitePassword: "",
    mostrarNueva: false,
    mostrarRepetida: false,
    mostrarMensaje: false,
    mensaje: {
      texto: "",
      color: "",
    },
    rules: {
      required: v => !!v || "Debes colocar este dato.",
      min: v => v.length >= 8 || "Mínimo 8 caracteres",
    },
  }),
  methods: {
    cambiarPassword() {
      if (this.nuevaPassword !== this.repitePassword) {
        this.mostrarMensaje = true;
        this.mensaje = {
          texto: "Las contraseñas no coinciden",
          color: "error",
        };
        return;
      }

      const payload = {
        metodo: "cambiar_pass",
        idUsuario: this.idUsuario,
        password: this.repitePassword,
      };

      HttpService.registrar(payload, "usuarios.php").then(resultado => {
        if (resultado) {
          this.mostrarMensaje = true;
          this.mensaje = {
            texto: "Contraseña actualizada correctamente",
            color: "success",
          };
          this.nuevaPassword = "";
          this.repitePassword = "";
        }
      });
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.form-password-wrapper {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-family: var(--font-body);
}

.dark-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

/* ===== Overrides v-text-field (Vuetify) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-counter {
  color: var(--text-tertiary) !important;
  font-size: 11px !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

@media (max-width: 600px) {
  .form-actions .btn-primary {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/FormCambiarPassword.vue